import { render, staticRenderFns } from "./_ActivityIcon.vue?vue&type=template&id=c2402f58&"
import script from "./_ActivityIcon.vue?vue&type=script&lang=js&"
export * from "./_ActivityIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports